import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../navbar/Navbar.css';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Offcanvas } from 'react-bootstrap';
import LogoutIcon from '@mui/icons-material/Logout';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MaleIcon from '@mui/icons-material/Male';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';


const Navbar = () => {
    const [nav, setNavbar] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const [userRole, setUserRole] = useState(null);
    const [userName, setUserName] = useState("");
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [userDetails, setUserDetails] = useState({});

    useEffect(() => {
        const role = localStorage.getItem('role');
        const user = JSON.parse(localStorage.getItem('user'));
        setUserRole(role);
        if (user) {
            const { firstName, lastName } = user;
            setUserName(`${firstName[0]}${lastName[0]}`);
            setUserDetails(user);

        }
    }, []);


    const changeBackground = () => {
        if (window.scrollY >= 80) {
            setNavbar(true);
        } else {
            setNavbar(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', changeBackground);
        return () => {
            window.removeEventListener('scroll', changeBackground);
        };
    }, []);

    const handleLogout = () => {
        localStorage.clear();
        window.location.reload();
    };
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const disableClassesPaths = ['/buyPage', '/propertyDescription', '/userRegister', '/userWishlist'];
    const disableClasses = disableClassesPaths.includes(location.pathname);
    const isBuyPage = location.pathname === '/buyPage';
    const isPropPage = location.pathname.startsWith('/propertyDescription');
    const isContactPage = location.pathname === '/contact';
    const isAboutPage = location.pathname === '/aboutUs';
    const isRegisterPage = location.pathname === '/userRegister';
    const user = location.pathname === '/user/userWishlist';

    return (
        <div className='z-3'>
            <nav className={`navbar nav-header navbar-expand-lg 
                ${!disableClasses ? (nav ? 'nav active' : '') : ''} 
                ${!disableClasses ? 'position-fixed' : ''} 
                ${isBuyPage ? 'buyPage-background ' : ''} 
                ${isAboutPage ? 'pagecolor ' : ''} 
                ${isPropPage ? 'propPage-background' : ''}  
                ${isContactPage ? 'contactPage-background' : ''}  
                ${isRegisterPage ? 'buyPage-background' : ''}  
                ${user ? 'buyPage-background' : ''}  
                 top-0 w-100 z-3`}>

                <div className="container-fluid nav-padding d-flex justify-content-between align-items-center">
                    <Link className="nav-logo" to="/">
                        <img src="/assets/images/logo/logo.png" alt="Logo" />
                    </Link>
                    <button className="navbar-toggler border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                        <span> <MenuIcon style={{ color: 'var(--bs-accent)', fontSize: 30 }} /></span>
                    </button>

                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav mb-2 mb-lg-0 d-flex align-items-center gap-5 mx-auto">

                            <li className="nav-item">
                                <Link className="nav-link" to="/buyPage" style={{ fontSize: '16px', fontWeight: '500', color: 'var(--bs-accent)' }}>Properties</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/blogs" style={{ fontSize: '16px', fontWeight: '500', color: 'var(--bs-accent)' }}>Invest / Buy Guide</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/contact" style={{ fontSize: '16px', fontWeight: '500', color: 'var(--bs-accent)' }}>Contact</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/aboutUs" style={{ fontSize: '16px', fontWeight: '500', color: 'var(--bs-accent)' }}>About Us</Link>
                            </li>

                        </ul>
                        <ul className="navbar-nav mb-2 mb-lg-0 ms-auto d-flex align-items-center">
                            {userRole === 'user' ? (
                                <li className="custom-nav-item" style={{ position: 'relative', marginRight: '20px' }}>
                                    <div
                                        className="d-flex align-items-center"
                                        style={{ cursor: 'pointer' }}
                                        onClick={toggleSidebar}
                                    >
                                        <div className="avatar-circle" style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            backgroundColor: '#d6ab5e',
                                            color: '#122620',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}>
                                            <span>{userName}</span>
                                        </div>
                                        <KeyboardArrowDownIcon style={{ color: '#d6ab5e', marginLeft: '5px' }} />
                                    </div>
                                </li>
                            ) : (
                                <>
                                    <li className="nav-item " style={{ marginRight: '12px' }}>
                                        <Link
                                            className="nav-link1 text-white p-2 px-3"
                                            to="/login"
                                            style={{
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                backgroundColor: 'var(--bs-accent)',
                                                borderRadius: "50px"
                                            }}
                                        >
                                            Login / Register
                                        </Link>
                                    </li>

                                </>
                            )}

                        </ul>
                    </div>

                </div>



            </nav>



            <Offcanvas show={sidebarOpen} onHide={toggleSidebar} placement="end" style={{ width: '300px' }}>
                <Offcanvas.Header style={{ backgroundColor: 'var(--bs-primary)' }} closeButton >

                    <Offcanvas.Title>
                        <div className="avatar-circle" style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '50%',
                            backgroundColor: '#d6ab5e',
                            color: '#122620',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: '0 auto'
                        }}>
                            <span>{userName}</span>
                        </div>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body style={{ background: "var(--bs-secondary)" }}>
                    <div style={{

                    }}>
                        <h4 className='text-center'>{userDetails.firstName} {userDetails.lastName}</h4>

                        <div>   <h6 style={{ marginBottom: "0px" }}>Email: </h6>  <p><EmailIcon className="me-1 profile-icon " />{userDetails.email}</p></div>

                        <div> <h6 style={{ marginBottom: "0px" }}>Age:</h6>
                            <p><CalendarTodayIcon className="me-1 profile-icon " />{userDetails.age}</p>
                        </div>
                        <div>
                            <h6 style={{ marginBottom: "0px" }}> Gender:</h6>   <p> <MaleIcon className="me-1 profile-icon " />{userDetails.gender}</p></div>
                        <div>
                            <h6 className='' style={{ marginBottom: "0px" }}>Phone:</h6> <p><LocalPhoneIcon className="me-1 profile-icon " />
                                {userDetails.phoneNumber}</p>
                        </div>
                    </div>
                    <hr />
                    <ul className="list-unstyled">
                        <li className='my-2'>
                            <button className="dropdown-item" onClick={() => navigate('/user/userWishlist')} style={{
                                // background: "var(--bs-accent)",
                                // width: "75px",
                                // padding: "5px 8px",
                                // borderRadius: "5px",

                                // display: "flex",
                                // justifyContent: "center",
                                // color: "#fff",
                                // marginBottom: "10px"
                            }}><BookmarksIcon style={{ color: "green", marginRight: "9px", fontSize: "18px" }} />Wishlist</button>
                        </li>
                        <li className='my-2'>
                            <button className="dropdown-item" onClick={handleLogout}
                                style={{
                                    // background: "#931313",
                                    // width: "75px",
                                    // padding: "5px 8px",
                                    // borderRadius: "5px",
                                    // color: "#fff",
                                    // display: "flex",
                                    // justifyContent: "center"
                                }}
                            ><LogoutIcon style={{ color: "red", marginRight: "8px", fontSize: "18px" }} /> Logout</button>
                        </li>
                    </ul>
                </Offcanvas.Body>
            </Offcanvas>



            {/* Offcanvas for mobile navigation */}
            <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                <div className="offcanvas-header d-flex justify-content-between" style={{ backgroundColor: "var(--bs-primary)", color: "#fff" }}>
                    <h5 className="offcanvas-title nav-logo" id="offcanvasNavbarLabel">
                        <img src="/assets/images/logo/logo.png" alt="" />
                    </h5>
                    <button type="button" className="" data-bs-dismiss="offcanvas" aria-label="Close" style={{ background: "transparent", border: "none" }}>
                        <CloseIcon style={{ color: '#fff' }} />
                    </button>
                </div>
                <div className="offcanvas-body" style={{ backgroundColor: 'var(--bs-secondary)' }}>
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link active" aria-current="page" to="/" style={{ fontSize: '16px', fontWeight: '500', fontFamily: 'sans-serif' }}>Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/buyPage" style={{ fontSize: '16px', fontWeight: '500', fontFamily: 'sans-serif' }}>Properties</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/blogs" style={{ fontSize: '16px', fontWeight: '500', fontFamily: 'sans-serif' }}>Invest / Buy Guide</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/contact" aria-disabled="true" style={{ fontSize: '16px', fontWeight: '500', fontFamily: 'sans-serif' }}>Contact</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/aboutUs" aria-disabled="true" style={{ fontSize: '16px', fontWeight: '500', fontFamily: 'sans-serif' }}>About Us</Link>
                        </li>
                        {userRole === 'user' && (
                            <li className="nav-item">
                                <div
                                    className="d-flex align-items-center"
                                    style={{ cursor: 'pointer', marginTop: '20px' }}
                                    onClick={toggleSidebar}
                                >
                                    <div className="avatar-circle" style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        backgroundColor: '#d6ab5e',
                                        color: '#122620',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>
                                        <span>{userName}</span>
                                    </div>
                                    <span style={{ marginLeft: '10px', color: '#122620', fontWeight: '500' }}>Profile</span>
                                </div>
                            </li>
                        )}
                        {userRole !== 'user' && (
                            <>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/login" style={{ fontSize: '16px', fontWeight: '500', fontFamily: 'sans-serif', backgroundColor: "#D6AD60", padding: 4 }}>Login</Link>
                                </li>
                            </>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
